import React, { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Trans } from "react-i18next";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { AlertComponent } from "../../Components/AlertComponent";
import { LoadingComponent } from "../../Components/Loading";
import { ProductsGrid } from "../../Components/Products/Grid";
import routes from "../../Helpers/Routes.json";
import { Context } from "../../Shared/Context/GlobalContext";

export default function Homepage() {
  const {
    selectedCategory,
    categoriesLoading,
    categories,
    cartProducts,
    setSelectedCategory,
  } = useContext(Context);
  const params = useParams();
  const location = useLocation();

  let category = categories.find((i) => params.category === i.slug);
  if (!category) {
    category = categories[0];
  }

  useEffect(() => {
    setSelectedCategory(category);
  }, [location.pathname]);

  if (categoriesLoading) {
    return <LoadingComponent />;
  }

  if (!params.category) {
    return (
      <Navigate
        to={routes.Homepage.category.replace(":category", category.slug)}
        state={{ ...location.state }}
      />
    );
  }

  const prodQty = cartProducts.reduce((carry, { product }) => {
    return product.quantity + carry;
  }, 0);

  return (
    <Container className="py-3" style={{ maxWidth: "1200px", paddingBottom: cartProducts.length > 0 ? "200px" : undefined }}>
      <ProductsGrid category={category} selectedCategory={selectedCategory} />
      <BottomAlert state={location.state} />

      {cartProducts.length > 0 && (
        <div
          className="fixed-bottom d-flex justify-content-center pb-3"
          style={{ bottom: "68px", zIndex: 1040, pointerEvents: "none" }}
        >
          <Link
            to={routes.OrderPage.index}
            className="btn btn-dark rounded-pill shadow-lg px-4 py-2 d-flex align-items-center gap-2"
            style={{ pointerEvents: "auto" }}
          >
            <Trans
              i18nKey={"Comprar {{count}} {{name}}"}
              values={{
                count: prodQty,
                name: prodQty === 1 ? "producto" : "productos",
              }}
            />
          </Link>
        </div>
      )}
    </Container>
  );
}

function BottomAlert({ state = {} }) {
  const [currentState, setCurrentState] = useState(state);
  useEffect(() => {
    setTimeout(() => {
      setCurrentState({});
    }, 3500);
  });

  if (currentState && currentState.product) {
    return (
      <AlertComponent variant={currentState.variant}>
        <span className="fw-bold">
          <Trans
            i18nKey={"{{name}} añadido al carrito"}
            values={{ name: currentState.product }}
          />
        </span>
      </AlertComponent>
    );
  }

  return null;
}
